import React from 'react';

import styled from 'styled-components';

import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

/* con "Non Binary" le 4 voci non stanno su una riga sola su schermi stretti:
   via le icone e testo più piccolo, le etichette bastano a distinguerle */
const StyledGenderGroup = styled(RadioButtonGroup)`
    @media (max-width: ${(props) => props.theme.NarrowScreenMaxWidth}) {
        .ant-radio-button-wrapper {
            padding: 0 0.5rem;
            font-size: 0.75rem;

            svg {
                display: none;
            }
        }
    }
`;

const GenderSelector = ({ value, onChange, disabled, emptyValue }) => {
    const options = [
        { label: 'Female', value: 'Female', icon: byPrefixAndName.fasl['venus'] },
        { label: 'Male', value: 'Male', icon: byPrefixAndName.fasl['mars'] },
        { label: 'Non Binary', value: 'NonBinary', icon: byPrefixAndName.fasl['mars-and-venus'] },
    ];
    if (emptyValue) {
        options.unshift({ label: 'Any', value: null, icon: byPrefixAndName.fasl['asterisk'] });
    }

    return (
        <StyledGenderGroup
            style={{ whiteSpace: 'nowrap' }}
            value={value}
            disabled={disabled}
            onChange={onChange}
            defaultValue="Female"
            options={options}
        />
    );
};

export { GenderSelector };
